/**
 * @author NikolaV
 */

import * as React from 'react';
import './FilterSelectionFeedback.scss';


export class TreeSelectionFeedback extends React.Component<{
    checkedCount: number;
    loadedItemsCount: number;
    totalItemsCount: number;
    onClearSelection: () => void;
    onSelectAll?: () => void;
    countTooltip: string;
}, {}> {
    render() {
        const { checkedCount, loadedItemsCount, totalItemsCount, onClearSelection, onSelectAll, countTooltip } = this.props;
        const canSelectAll = typeof onSelectAll === 'function';

        if (loadedItemsCount || checkedCount) {
            return <div className='panel-selection-feedback'>
                <span className='no-break-text' title={countTooltip}>({loadedItemsCount} / {totalItemsCount})</span>
                <span className='button' onClick={onClearSelection}>{kuura.getMessage('js_map.clear_selection')}</span>
            </div>;
        }

        return <div className='panel-selection-feedback'>
            <span>{kuura.getMessage('js_map.no_selection')}</span>
            { canSelectAll && <span className='button js-select-all' onClick={onSelectAll}>{kuura.getMessage('general.select_all')}</span> }
        </div>;
    }
}
